var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 1041"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_272_10205)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.25,
    stroke: "url(#paint1_linear_272_10205)",
    strokeOpacity: 0.48,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 37.5C18 33.7721 21.0221 30.75 24.75 30.75H35.25C38.9779 30.75 42 33.7721 42 37.5V39C42 42.7279 38.9779 45.75 35.25 45.75H24.75C21.0221 45.75 18 42.7279 18 39V37.5Z",
    fill: "url(#paint2_linear_272_10205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.25 21C23.25 17.2721 26.2721 14.25 30 14.25C33.7279 14.25 36.75 17.2721 36.75 21C36.75 24.7279 33.7279 27.75 30 27.75C26.2721 27.75 23.25 24.7279 23.25 21Z",
    fill: "url(#paint3_linear_272_10205)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_272_10205",
    x1: 10.875,
    y1: 10.875,
    x2: 41.25,
    y2: 57.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF91B8",
    stopOpacity: 0.32
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_272_10205",
    x1: 22.5,
    y1: 2.23517e-7,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7193",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_272_10205",
    x1: 34,
    y1: 31,
    x2: 34.0529,
    y2: 45.7355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB47FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590192,
    stopColor: "#AE27FF",
    stopOpacity: 0.415923
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902256,
    stopColor: "#5200FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_272_10205",
    x1: 26,
    y1: 16,
    x2: 35.9218,
    y2: 23.8961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574918,
    stopColor: "#FF7193",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5200FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f20daeeff728bf78ff738df78dfcf065.svg";
export { ForwardRef as ReactComponent };